/**
 * Descripción: Helper que ayuda a convertir una fecha en texto no tradicional DD/MM/YY.
 *
 * Implementación: Recibe como parametro un array, este array debe de ser de textos para poder que funciones (["DD/MM/YY"] o tambien ["DD/MM/YY", "DD/MM/YY"])., lo va a recorrer y extraera los elementos y los va a convertir en una fecha, retorna un objeto.
 * { day, month, monthName, year }
 *
 * Bugs: Solo sirve para un tipo de fecha en especial.
 */

const returnDateText = (array) => {
  const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  let date;
  let day;
  let month;
  let monthName;
  let year;

  array.forEach((element) => {
    date = element.split("/");
    day = date[0];
    month = Number(date[1]);
    monthName = months[month - 1];
    year = date[2];
  });

  return { day, month, monthName, year };
};

export default returnDateText;
